import React, { useEffect, useState } from 'react';
import ReasoningList from './ReasoningList';
import { PropTypes } from 'prop-types';
import Utils from '@/common/utils/utils';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

ThinkingLoading.propTypes = {
    reasoningData: PropTypes.any,
    defaultText: PropTypes.any,
    fontSize: PropTypes.any,
    color: PropTypes.any,
    duration: PropTypes.any,
    stagger: PropTypes.any
};

export default function ThinkingLoading({
    reasoningData,
    defaultText = trI18n('AI_THINKING'),
    fontSize = '13px',
    color = '#2e3138f5',
    duration = 0.9,
    stagger = 0.08
}) {
    useTranslationSubscription();
    const [showDetail, setShowDetail] = useState(false);
    const [defaultTitle, setDefaultTitle] = useState(defaultText);

    const handleShowDetail = () => {
        if(reasoningData?.length > 0){
            setShowDetail(!showDetail);
        }
    }
    
    useEffect(() => {
       if(reasoningData?.length > 0){
            let lastItem = reasoningData[reasoningData?.length - 1];
            if(!lastItem?.isDone){
                const newTitle = !Utils.isEmptyString(lastItem?.title) ? lastItem?.title : trI18n('AI_THINKING')
                setDefaultTitle(newTitle);
            }
       }
    }, [reasoningData]);

    const trimStars = (str) =>{
        if(!str) return str
        return str.replace(/^\*+|\*+$/g, '');
    }
    return (
        <div style={{ display: 'inline-block' }}>
            <style>{`
        @keyframes thinkingFade {
          0%   { opacity: 1; transform: translateY(0); }
          50%  { opacity: 1; transform: translateY(-1px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes detailFade {
          0%   { opacity: 0.8; transform: translateY(0); }
          50%  { opacity: 0.9; transform: translateY(-0.5px); }
          100% { opacity: 0.8; transform: translateY(0); }
        }
        .thinking-char {
          display: inline-block;
          animation-name: thinkingFade;
          animation-iteration-count: infinite;
          animation-timing-function: ease-in-out;
        }
        .detail-char {
          display: inline-block;
          animation-name: detailFade;
          animation-iteration-count: infinite;
          animation-timing-function: ease-in-out;
        }
      `}</style>

            {/* Text chính */}
            <div
                style={{
                    fontSize,
                    fontWeight: 500,
                    color,
                    cursor: reasoningData.length > 0 ? 'pointer' : 'default'
                }}
                onClick={handleShowDetail}
            >
                {Array.from(trimStars(defaultTitle))?.map((ch, i) => (
                    <span
                        key={`main-${i}`}
                        className="thinking-char"
                        style={{
                            animationDuration: `${duration}s`,
                            animationDelay: `${i * stagger}s`
                        }}
                    >
                        {ch === ' ' ? '\u00A0' : ch}
                    </span>
                ))}
            </div>

            {/* Detail: toggle khi click */}
            {showDetail && <ReasoningList reasoningData={reasoningData} />}
        </div>
    );
}
